"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _Tabs = _interopRequireDefault(require("@eig-builder/core-ui/Tabs"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Export our custom tabs
var FullWidthTab = (0, _styles.withStyles)(function (theme) {
  return {
    root: _objectSpread({}, _helpers.hoverEffect, {
      '& button': _objectSpread({}, _helpers.heightValues, {
        opacity: '1',
        minWidth: '0px !important'
      }, _helpers.labelStyling, {
        padding: 0
      }),
      '& button[aria-selected="false"]': {
        '& span': {
          fontWeight: '400 !important',
          color: theme.palette.black.main
        },
        '& path': {
          fill: theme.palette.black.main,
          opacity: '0.8'
        }
      }
    }, _helpers.displayFullWidth)
  };
})(_Tabs.default);
var _default = FullWidthTab;
exports.default = _default;